/// <amd-module name="Build/Admin/Agent/Stores/AddUserCapabilityPanelStore" />
import { Store } from "VSS/Reflux/Store";

export interface IAddUserCapabilityPanelStoreState {
    isOpen: boolean;
}

export class AddUserCapabilityPanelStore extends Store {
    public state: IAddUserCapabilityPanelStoreState;

    constructor() {
        super("AddUserCapabilityPanelStoreChanged");

        this.state = {
            isOpen: false
        };
    }

    public showPanel = () => {
        this.state = {
            isOpen: true
        };
        this.emitChanged();
    }

    public dismissPanel = () => {
        this.state = {
            isOpen: false
        };
        this.emitChanged();
    }
}
